import { Box, css } from '@mui/material'

import { useMQ } from '../hooks/useMQ'
import { CONFIG } from '../utils/config'
import { LinkedinIcon, SocialMediaX, DiscordIcon, YoutubeIcon } from './icons'

export function SocialMedia() {
  const { isBelowXsSize } = useMQ()

  const getMediaStyle = () => {
    if (isBelowXsSize) {
      return css`
        width: 32px;
      `
    }
  }

  const styles = {
    mediaWrapper: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 300px;
      margin-bottom: 32px;
    `,
    mediaIcon: css`
      &:hover svg path {
        fill: #ececec !important;
      }
    `,
    media: css`
      cursor: pointer;
      & path {
        fill: #999999;
      }
      ${getMediaStyle()}
    `,
  }

  return (
    <Box css={styles.mediaWrapper}>
      <a
        css={styles.mediaIcon}
        href={CONFIG.twitterLink}
        target='_blank'
        rel='noopener noreferrer'
      >
        <SocialMediaX css={styles.media} width={32} height={32} />
      </a>
      <a
        css={styles.mediaIcon}
        href={CONFIG.discordLink}
        target='_blank'
        rel='noopener noreferrer'
      >
        <DiscordIcon css={styles.media} width={32} height={32} />
      </a>
      <a
        css={styles.mediaIcon}
        href={CONFIG.youtubeLink}
        target='_blank'
        rel='noopener noreferrer'
      >
        <YoutubeIcon css={styles.media} width={32} height={32} />
      </a>
      <a
        css={styles.mediaIcon}
        href={CONFIG.linkedInLink}
        target='_blank'
        rel='noopener noreferrer'
      >
        <LinkedinIcon width={32} height={30} css={styles.media} />
      </a>
    </Box>
  )
}
